var Reflux=require("reflux");
module.exports=Reflux.createActions(["search"]);